import { render, staticRenderFns } from "./OneAnswer.vue?vue&type=template&id=e6a6349e&"
import script from "./OneAnswer.vue?vue&type=script&lang=js&"
export * from "./OneAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports